







































import Vue from "vue";

// Import External Components
import TextLayerBeside from "@miele/component-library-vue/src/components/modules/content/image-block/TextLayerBeside.vue";
import HeaderSection from "@miele/component-library-vue/src/components/modules/header/HeaderSection.vue";
import TeaserTextLayer from "@miele/component-library-vue/src/components/elements/cards/TeaserTextLayer.vue";
import LayoutTeaserGrid from "@miele/component-library-vue/src/components/layouts/LayoutTeaserGrid.vue";
import BreadCrumb from "@miele/component-library-vue/src/components/modules/pages/BreadCrumb.vue";
import Block from "@miele/component-library-vue/src/components/content/layouts/Block.vue";

// Import Internal Components
import LayoutRecipeDetail from "@/components/details/LayoutRecipeDetail.vue";
import RecipeTile from "@/components/RecipeTile.vue";

// Import Models
import { RecipeSchema } from "../models/recipe.model";
const recipe: RecipeSchema | {} = {};

export default Vue.extend({
  name: "Detail",
  data() {
    return {
      otherRecipesImage: "",
    };
  },
  computed: {
    recipe() {
      return this.$store.state.currentRecipe;
    },
    heroImage(): string {
      return this.recipe.image.replace("?imwidth=1920", "");
    },
    translations() {
      return this.$store.state.translations;
    },
    recipes() {
      return this.$store.state.recipes.data;
    },
  },
  components: {
    BreadCrumb,
    TextLayerBeside,
    LayoutRecipeDetail,
    TeaserTextLayer,
    HeaderSection,
    RecipeTile,
    LayoutTeaserGrid,
    Block,
  },
  mounted() {
    this.$store.dispatch("addLoader");
    (this as any).loadRecipe();
  },
  methods: {
    async loadRecipe() {
      const id = this.$route.params.id;
      this.$store.commit("SET_SINGLE_RECIPE", null);
      await this.$store.dispatch("fetchSingleRecipe", id);
      await this.$store.dispatch("fetchGroups");
      
      await this.loadRelatedRecipes();
    },
    async loadRelatedRecipes() {
      const tag = this.$store.state.currentRecipe.tags[0].id;
      const payload = {
        pageSize: 6,
        page: 1,
        tags: [tag],
      };
      await this.$store.dispatch("fetchRecipes", payload);
      await this.loadOtherRecipesImage();
      this.$store.dispatch("removeLoader");
    },
    async loadOtherRecipesImage() {
      const recipes = await this.$store.state.recipes.data;
      this.otherRecipesImage =
        recipes[
          Math.floor(Math.random() * recipes.length)
        ]?.recipe.thumbnailImage;
    },
    navigateBack(event: MouseEvent) {
      this.$router.push({
        path: "/",
      });
      event.preventDefault();
    },
  },
});
